import axios from 'axios'


const mapLocation = (q, city, distance) => {
    if (city) {
        q.location = { city }
        if (distance && distance > 0) {
            q.location.distance = distance
        }
    }
}

const mapCompensation = (q, comp, compType) => {
    if (comp) {
        q.compensation = {
            minimum: comp,
            type: compType
        }
    }
}

const mapQuery = q => {
    const query = {}
    const { keywords, city, distance, compensation, compensationType } = q
    query.keywords = keywords || ''
    mapLocation(query, city, distance)
    mapCompensation(query, compensation, compensationType)
    return query
}

const makeSearchRequest = (query, token, offset, size) => ({
    action: 'search',
    payload: {
        query: mapQuery(query),
        token: token,
        offset: offset || 0,
        size: size || 100
    }
})

export const searchGigs = async (query, token, offset, size) => {
    const serviceUrl = process.env.REACT_APP_AGENT_URL

    const gigs = await axios.post(serviceUrl, makeSearchRequest(query, token, offset, size))

    return gigs
}